var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer"},[_c('IconStarRounded',{staticClass:"[transition-opacity,transition-opacity] duration-100",class:[
      _vm.isActive ? 'text-lime' : 'opacity-20 hover:opacity-30 text-core' ]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }